import React from 'react';
import Header from '../../components/common/Header';
import Hero from '../../components/about/Hero';
import FeatureSection from '../../components/about/FeatureSection';
import FeaturesCards from '../../components/about/FeaturesCards';
import SolutionsSection from '../../components/about/SolutionsSection';
import HowItWorksSection from '../../components/about/HowItWorksSection';
import DifferentialSection from '../../components/about/DifferentialSection';
import Footer from '../../components/common/Footer';

const QuemSomos = () => {
  return (
    <>
      <Header />
      <Hero />
      <FeatureSection />
      <FeaturesCards />
      <SolutionsSection />
      <HowItWorksSection />
      <DifferentialSection />
      <Footer />
    </>
  );
};

export default QuemSomos;